import { render, staticRenderFns } from "./WidthFullIcon.vue?vue&type=template&id=fdc2dd24"
import script from "./WidthFullIcon.vue?vue&type=script&lang=ts"
export * from "./WidthFullIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports